export function initMapLoader() {
    const mapContainer = document.getElementById('rwl-site-map');
    const skeleton = document.getElementById('map-skeleton');

    if (!mapContainer || !skeleton) return;
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                setTimeout(() => {
                    skeleton.classList.add('hidden');
                }, 500);
                observer.disconnect();
            }
        });
    });

    observer.observe(mapContainer, {
        childList: true,
        subtree: true
    });

    setTimeout(() => {
        skeleton.classList.add('hidden');
        observer.disconnect();
    }, 5000);
}